import { memo } from 'react';
import { Button, Text } from '../../components';
import { GET_IN_TOUCH_FORM_ID, scrollToElement } from '../../utils';
import "./MainSection.scss";

const MemoComponent = function({ id }: { id: string }) {
  return (
    <section id={id} className="main-section">
      <div className="section-content">
        <Text variant="title1" weight={700} align="center">
          Online Business Consulting
        </Text>

        <Text variant="subtitle1" weight={500} align="center">
          Empowering your growth through expert online business consulting
        </Text>

        <Button label="Get in Touch" size="md" onClick={() => scrollToElement(GET_IN_TOUCH_FORM_ID)} />
      </div>
    </section>
  )
};

export const MainSection = memo(MemoComponent);